function capitalizeEveryWord(inputString) {
  // Split the string into words
  const words = inputString.split(' ');

  // Capitalize the first letter of each word
  const capitalizedWords = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1));

  // Join the words back together with a space
  const capitalizedString = capitalizedWords.join(' ');

  return capitalizedString;
}

// Labels that suppliers emit as their own <div> inside `additional_info`. The generated
// pattern tolerates attributes on the tag (`<div class="...">`) and content spanning several
// lines (`s` flag); `.*?` stays lazy so a match ends at the first closing tag instead of
// swallowing the blocks that follow it.
const PRICING_INFO_DIV_LABELS = ['Deposit information', 'Cancellation information'];

// The penalty description is emitted inline rather than as its own block. Any line break
// immediately before it is consumed too, so stripping the description does not leave a
// dangling <br> at the end of the content.
const PENALTY_DESCRIPTION_PATTERN =
  /(?:<br\s*\/?>\s*)?<b>\s*Penalty description:\s*<\/b>.*?(?=<br|$)/gis;

export const removePricingInformation = (additionalInfo) => {
  if (!additionalInfo) {
    return additionalInfo;
  }

  let result = additionalInfo.replace(PENALTY_DESCRIPTION_PATTERN, '');

  PRICING_INFO_DIV_LABELS.forEach((label) => {
    result = result.replace(new RegExp(`<div\\b[^>]*>\\s*${label}:.*?</div>`, 'gis'), '');
  });

  return result;
};

export const formatRoomDescription = (roomDescription) => {
  if (!roomDescription) return '';
  let newRoomDescription = roomDescription;

  // Replace common abbreviations
  newRoomDescription = newRoomDescription.replace(/NON-REFUNDABLE/g, 'Non-refundable');
  newRoomDescription = newRoomDescription.replace(/NON-CHANGEABLE/g, 'Non-changeable');
  newRoomDescription = newRoomDescription.replace(/PREPAY IN FULL/g, 'Prepay in full');
  newRoomDescription = newRoomDescription.replace(/-S-/g, '');
  newRoomDescription = newRoomDescription.replace(/\*/g, ' - ');

  newRoomDescription = newRoomDescription.toLowerCase();

  // Split the text into sentences
  const sentences = newRoomDescription.split('. ');

  // Capitalize the first letter of each sentence
  const formattedSentences = sentences.map(
    (sentence) => sentence.charAt(0).toUpperCase() + sentence.slice(1),
  );

  // Join the sentences back together
  const formattedText = formattedSentences.join('. ');

  return capitalizeEveryWord(formattedText);
};

const commissionTerms = ['commissionable', 'commission'];

const commissionPatterns = [
  {
    regex: new RegExp('\\d+\\s*(percent|pct)?\\s*(commissionable|commission|comm)', 'gi'),
  },
  {
    regex: new RegExp(`\\b(${commissionTerms.join('|')})\\b`, 'gi'),
  },
];

export const removeCommissionTerms = (text) => {
  if (!text) return '';
  let cleaned = text;

  commissionPatterns.forEach(({ regex }) => {
    cleaned = cleaned.replace(regex, '');
  });
  return cleaned.trim();
};

/** e.g. `1 King Bed - King` from `room.type` + `room.bedTypes` */
export function joinRoomTypeAndBeds(room) {
  if (!room) return '';
  return [room.type, room.bedTypes?.length ? room.bedTypes.join(', ') : '']
    .filter(Boolean)
    .join(' - ');
}

export function getRoomFormattedDescriptionBody(room, doShowAgentCommission) {
  if (!room) return '';
  const description =
    room.originalFormattedDesc ||
    room.formattedDesc ||
    formatRoomDescription(room.originalDesc || room.desc);
  return doShowAgentCommission ? description : removeCommissionTerms(description);
}
